import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalDate,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
} from "component/common";
import { withTranslation } from "react-i18next";
import { NewItemDepts, ItemDepts, updateCommon } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";
import moment from "moment";
import { getCommonApi, commonCreateApi } from "redux/actions/common";

export default class EditdepartmentCLass extends Component {
  state = {
    itemId: null,
    desc: null,
    validityperiod: null,
    fesequence: null,
    option: [
      { label: " 1 Year", value: 1 },
      { label: " 2 Year", value: 2 },
      { label: " 3 Year", value: 3 },
      { label: "Unlimited", value: 4 },
    ],
    code: null,
    fdate: new Date(),
    tdate: new Date(),
    dept: true,
    cash: false,
    sales: false,
    retail: false,
    salon: false,
    service: false,
    voucher: false,
    prepaid: false,
    ftrial: false,
    ispackage: false,
    compound: false,
    max_Date: new Date(),
    depts: [],
    images: null,
    image: null,
    updateImage: false,
    updateId: null,
  };

  componentDidMount = () => {
    let { itemId } = this.state;
    itemId = window.location.pathname.split("/")[4];
    this.setState({ itemId });
    console.log(itemId);
    this.listofdept(itemId);
  };

  listofdept = async (code) => {
    let {
      desc,
      count,
      fesequence,
      fdate,
      tdate,
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ispackage,
      compound,
      ftrial,
      temp,
      updateId,
      images,
    } = this.state;
    await this.props.ItemDepts().then((res) => {
      let objIndex = res.findIndex((obj) => obj.itmCode == code);
      console.log(objIndex);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      console.log(temp, "tempCheck");
      desc = temp.itmDesc;
      count = temp.validityPeriod;
      fesequence = temp.itmSeq;
      fdate = temp?.vilidityFromDate
        ? moment(temp.vilidityFromDate)._d
        : new Date();
      tdate = temp?.vilidityToDate
        ? moment(temp.vilidityToDate)._d
        : new Date();
      dept = temp.itmStatus;
      cash = temp.allowcashsales;
      sales = temp.itmShowonsales;
      retail = temp.isRetailproduct;
      salon = temp.isSalonproduct;
      service = temp.isService;
      voucher = temp.isVoucher;
      prepaid = temp.isPrepaid;
      ftrial = temp.isfirsttrial;
      ispackage = temp.isPackage;
      compound = temp.isCompound;
      images = temp.deptPic;
      updateId = temp.itmId;
      this.setState(
        {
          desc,
          count,
          fesequence,
          fdate,
          tdate,
          dept,
          cash,
          sales,
          retail,
          salon,
          service,
          voucher,
          prepaid,
          ftrial,
          ispackage,
          compound,
          images,
          updateId,
        },
        () => {
          this.props.getCommonApi(`itemdeptimage/${updateId}`).then((res) => {
            console.log(res, "imageRes");
            this.setState({
              image: res.data.deptpic,
            });
          });
        }
      );
    });
  };

  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let { deptcode, desc, count, fesequence, fdate, tdate } = this.state;
    if (name == "deptcode") {
      deptcode = value;
      this.setState({ deptcode });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "count") {
      count = value;
      this.setState({ count });
      console.log(count);
      if (count == 1) {
        tdate = new Date();
        tdate.setFullYear(tdate.getFullYear() + 1);
        console.log(tdate);
        this.setState({ tdate });
      } else if (count == 2) {
        tdate = new Date();
        tdate.setFullYear(tdate.getFullYear() + 2);
        this.setState({ tdate });
      } else if (count == 3) {
        tdate = new Date();
        tdate.setFullYear(tdate.getFullYear() + 3);
        this.setState({ tdate });
      } else {
        tdate = new Date();
        tdate.setFullYear(tdate.getFullYear() + 978);
        this.setState({ tdate });
      }
    }
    if (name == "fe") {
      fesequence = value;
      this.setState({ fesequence });
    }
    if (name == "fdate") {
      fdate = value;
      this.setState({ fdate });
    }
    if (name == "tdate") {
      tdate = value;
      this.setState({ tdate });
    }
  };

  tempone = ({ target: { value, name } }) => {
    console.log(value, name);
    let {
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ftrial,
      ispackage,
      compound,
    } = this.state;
    if (name == "dept") {
      dept = value;
      this.setState({ dept });
    }
    if (name == "cash") {
      cash = value;
      this.setState({ cash });
    }
    if (name == "sales") {
      sales = value;
      this.setState({ sales });
    }
    if (name == "retail") {
      retail = value;
      this.setState({ retail });
    }
    if (name == "salon") {
      salon = value;
      this.setState({ salon });
    }
    if (name == "service") {
      service = value;
      this.setState({ service });
    }
    if (name == "voucher") {
      voucher = value;
      this.setState({ voucher });
    }
    if (name == "prepaid") {
      prepaid = value;
      this.setState({ prepaid });
    }
    if (name == "ftrial") {
      ftrial = value;
      this.setState({ ftrial });
    }
    if (name == "ispackage") {
      ispackage = value;
      this.setState({ ispackage });
    }
    if (name == "compound") {
      compound = value;
      this.setState({ compound });
    }
  };

  Addnewequiment = async () => {
    let {
      deptcode,
      desc,
      count,
      fesequence,
      fdate,
      tdate,
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ftrial,
      ispackage,
      compound,
      objIndex,
      images,
      updateImage,
      itemId,
      updateId,
    } = this.state;
    if (desc == null) {
      Toast({
        type: "error",
        message: "Please check required field",
      });
    } else {
      let newdept = {
        itmCode: deptcode,
        itmDesc: desc,
        itmStatus: dept,
        itmSeq: fesequence,
        allowcashsales: cash,
        itmShowonsales: sales,
        isfirsttrial: ftrial,
        isVoucher: voucher,
        isPrepaid: prepaid,
        isRetailproduct: retail,
        isSalonproduct: salon,
        isPackage: ispackage,
        validityPeriod: count,
        isService: service,
        isCompound: compound,
        deptPic: images,
        vilidityFromDate: fdate,
        vilidityToDate: tdate,
        vilidityFromTime: fdate,
        vilidityToTime: tdate,
      };
      await this.props
        .updateCommon(
          `ItemDepts/update?where=%7B%22itmCode%22%3A%20%22${this.state.itemId}%22%7D

    `,
          newdept
        )
        .then((data) => {
          Toast({
            type: "success",
            message: "Updated Successfully",
          });
          if (updateImage) {
            let formData = new FormData();

            formData.append(`deptpic`, images);
            formData.append(`dept_code`, itemId);

            this.props
              .commonCreateApi(`deptimageupload/`, formData)
              .then((res) => {
                console.log(res, "response");

                Toast({
                  type: "success",
                  message: "Successfully Added",
                });
              });
          }
          this.handleimput();
          //this.props.history.goBack();
        })
        .catch((e) => console.log(e));
      this.props.history.push(`/admin/backend/itemclassification/department`);
    }
  };

  handleimput = () => {
    let {
      deptcode,
      desc,
      count,
      fesequence,
      fdate,
      tdate,
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ispackage,
      compound,
      ftrial,
      updateImage,
    } = this.state;

    desc = "";
    count = "";
    fesequence = "";
    fdate = new Date();
    tdate = new Date();
    dept = false;
    cash = false;
    sales = false;
    retail = false;
    salon = false;
    service = false;
    voucher = false;
    prepaid = false;
    ispackage = false;
    compound = false;
    ftrial = false;
    updateImage = false;
    this.setState({
      deptcode,
      desc,
      count,
      fesequence,
      fdate,
      tdate,
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ftrial,
      ispackage,
      compound,
      updateImage,
    });
  };

  handleDatePick = (name, value) => {
    console.log(name, value);
    let { fdate, tdate } = this.state;
    if ((name = "fdate")) {
      fdate = value;
    }
    if ((name = "tdate")) {
      tdate = value;
    }
    this.setState({
      fdate,
      tdate,
    });
  };
  handleimageChange = (event) => {
    const displayImage = URL.createObjectURL(event.target.files[0]);

    this.setState({
      images: event.target.files[0],
      image: displayImage,
      updateImage: true,
    });
  };

  render() {
    let { t } = this.props;
    let {
      deptcode,
      desc,
      fesequence,
      option,
      count,
      fdate,
      tdate,
      dept,
      cash,
      sales,
      retail,
      salon,
      service,
      voucher,
      prepaid,
      ispackage,
      compound,
      ftrial,
      max_Date,
      image,
      images,
      itemId,
    } = this.state;
    return (
      <div className="bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h4 className="label-head text-center text-md-left text-lg-left mt-4 mb-0">
                {t("Department Data Entry")}
              </h4>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-6 col-lg-6 float-right">
            <div className="mt-4">
              <p>{t("Picture")}</p>
              <div className="mt-3 ml-2">
                <input
                  type="file"
                  onChange={(event) => this.handleimageChange(event)}
                />
              </div>
            </div>
            <div className="mt-3 imagecontainer d-flex justify-content-center justify-content-md-start">
              <img src={image} alt="" width="100" height="66" />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mt-4">
              <span>{t("Department Code")}</span>
              <span style={{ color: "red" }}>*</span>
              <div className="input-group">
                <NormalInput
                  onChange={this.temp}
                  value={itemId}
                  type="number"
                  name="deptcode"
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-4">
            <span>{t("Description")}</span>
            <span style={{ color: "red" }}>*</span>
            <div className="input-group">
              <NormalInput onChange={this.temp} value={desc} name="desc" />
            </div>
          </div>
          <div className="col-12 col-md-6 mt-4">
            <p>{t("Validity Period")}</p>
            <div className="input-group">
              <NormalSelect
                options={option}
                value={count}
                onChange={this.temp}
                name="count"
              />
            </div>
          </div>
          <div className="d-md-flex col-12 col-md-6">
            <div className="input-group pt-4 p-1">
              <p>{t("Validity From")}</p>
              <div className="input-group">
                <NormalDate
                  onChange={this.handleDatePick}
                  value={fdate}
                  name="fdate"
                  showYearDropdown={true}
                  dateFormat="MM/dd/yyyy"
                />
              </div>
            </div>
            <div className="input-group pt-4 p-1">
              <p>{t("Validity To")}</p>
              <div className="input-group">
                <NormalDate
                  onChange={this.handleDatePick}
                  value={tdate}
                  name="tdate"
                  showYearDropdown={true}
                  dateFormat="MM/dd/yyyy"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mt-4">
              <span>{t("FE Sequence No")}</span>
              <span style={{ color: "red" }}>*</span>
              <div className="input-group">
                <NormalInput
                  onChange={this.temp}
                  type="number"
                  value={fesequence}
                  name="fe"
                />
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex mt-4 ml-3">
              <NormalCheckbox
                checked={dept}
                name="dept"
                onChange={this.tempone}
              />
              <p>{t("Department is currently active")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={cash}
                name="cash"
                onChange={this.tempone}
              />
              <p>{t("Allow Cash Sales")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={sales}
                name="sales"
                onChange={this.tempone}
              />
              <p>{t("Show on Sales")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={ftrial}
                name="ftrial"
                onChange={this.tempone}
              />
              <p>{t("This is first trial")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={retail}
                name="retail"
                onChange={this.tempone}
              />
              <p>{t("This is retail product")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={salon}
                name="salon"
                onChange={this.tempone}
              />
              <p>{t("This is salon product")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={service}
                name="service"
                onChange={this.tempone}
              />
              <p>{t("This is service")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={voucher}
                name="voucher"
                onChange={this.tempone}
              />
              <p>{t("This is voucher")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={prepaid}
                name="prepaid"
                onChange={this.tempone}
              />
              <p>{t("This is prepaid")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={ispackage}
                name="ispackage"
                onChange={this.tempone}
              />
              <p>{t("This is package")}</p>
            </div>
            <div className="d-flex mt-2 ml-3">
              <NormalCheckbox
                checked={compound}
                name="compound"
                onChange={this.tempone}
              />
              <p>{t("This is Compound")}</p>
            </div>
          </div>

          <div className="mt-3 col-12 col-md-2">
            <NormalButtonBackend
              mainbg={true}
              label={"Update"}
              onClick={() => this.Addnewequiment()}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      NewItemDepts,
      ItemDepts,
      getCommonApi,
      updateCommon,
      commonCreateApi,
    },
    dispatch
  );
};

export const Editdepartment = withTranslation()(
  connect(null, mapDispatchToProps)(EditdepartmentCLass)
);
